import { motion } from 'framer-motion';
import { SectionHeader } from './Services';

const facts = [
  { k: 'Grundat', v: '2002' },
  { k: 'Bas', v: 'Tenhult, Jönköping' },
  { k: 'Område', v: 'Hela Sverige' },
  { k: 'Standard', v: 'SS-EN 14960' },
];

export default function About() {
  return (
    <section id="om-oss" className="relative py-16 sm:py-20 bg-sand">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 lg:col-start-1 order-2 lg:order-1">
            <motion.div
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="relative max-w-[70%] mx-auto"
            >
              <div className="relative aspect-[4/5] rounded-[2.5rem] bg-gradient-to-br from-sky via-grape to-tomato p-1.5 shadow-bouncy">
                <div className="relative h-full w-full rounded-[2.2rem] bg-cream overflow-hidden grain">
                  <div className="absolute inset-0 grid place-items-center">
                    <div className="text-center px-8">
                      <div className="font-display text-7xl sm:text-8xl font-bold text-ink leading-none">20+</div>
                      <div className="mt-3 text-lg font-medium text-ink/70">år av studsande glädje</div>
                      <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink text-cream px-4 py-2 text-sm font-semibold">
                        <span>👑</span> Sedan 20022 
                      </div>
                    </div>
                  </div>
                  {/* Confetti */}
                  <div className="absolute top-8 left-8 size-4 rounded-sm bg-tomato rotate-12" />
                  <div className="absolute top-16 right-12 size-3 rounded-full bg-grass" />
                  <div className="absolute bottom-20 left-12 size-5 rounded-md bg-sun -rotate-12" />
                  <div className="absolute bottom-12 right-16 size-3 rounded-full bg-grape" />
                  <div className="absolute top-1/2 left-6 size-2 rounded-full bg-bubble" />
                </div>
              </div>
              <motion.div
                animate={{ y: [0, -10, 0], rotate: [0, 6, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -top-4 -right-4 size-20 rounded-full bg-sun border-4 border-cream shadow-pop grid place-items-center text-3xl"
              >
                🏰
              </motion.div>
            </motion.div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <SectionHeader
              eyebrow="Om Borgakungen"
              title={<>Familjeföretaget som <span className="text-grass">studsar</span> i hela Sverige.</>}
              description="Sedan 2002 har vi levererat upplevelser till privatfester, skolor, kommuner och nationella turnéer — med bas i Tenhult levererar vi dagligen till Jönköping, Nässjö och hela Jönköpings län. Allt vi gör handlar om en sak — att skapa rena, säkra och oförglömliga skratt."
            />

            <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-4">
              {facts.map((f, i) => (
                <motion.div
                  key={f.k}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="rounded-2xl bg-cream border border-ink/10 p-5 shadow-[0_8px_20px_-12px_rgba(15,27,45,0.2)]"
                >
                  <div className="text-xs font-semibold uppercase tracking-wider text-ink/50">{f.k}</div>
                  <div className="mt-1.5 font-display text-2xl font-semibold">{f.v}</div>
                </motion.div>
              ))}
            </div>

            <p className="mt-8 text-ink/70 leading-relaxed text-pretty">
              Våra produkter tillverkas i Europa och uppfyller den europeiska säkerhetsstandarden
              <span className="font-semibold text-ink"> SS-EN 14960</span>. Vi väljer alltid kvalitet före kvantitet — för
              att din fest ska vara lika trygg som rolig.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
